import { render } from "./RecentlyPage.vue?vue&type=template&id=04de8635&scoped=true"
import script from "./RecentlyPage.vue?vue&type=script&lang=js"
export * from "./RecentlyPage.vue?vue&type=script&lang=js"

import "./RecentlyPage.vue?vue&type=style&index=0&id=04de8635&lang=scss&scoped=true"

import exportComponent from "/srv/swensa.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04de8635"]])

export default __exports__